<template>

  <b-card 
    title="Pistoleo temprano"
    sub-title="Lectura de seriales">

    <b-row>
      <b-col cols="12">

        <product-enlistment-card :stowage-id="stowageId"/>

      </b-col>
    </b-row>

  </b-card>
  
</template>

<script>
import router from '@/router'
import { BRow, BCol, BTabs, BTab, BCard } from 'bootstrap-vue'
import ProductEnlistmentCard from './ProductEnlistmentCard.vue'

export default {
  components: {
    BRow,
    BCol,
    BTabs,
    BTab,
    BCard,

    ProductEnlistmentCard,
  },
  data() {
    return {
      stowageId: null,
    }
  },
  created() {
    this.stowageId = router.currentRoute.params.stowage_id
    console.log(this.stowageId)
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>